import React from 'react'
import { Card, Spinner } from '@shopify/polaris'
import LappaPolarisDataTableShell from 'components/LappaPolarisDataTableShell'
import NoDataMessage from 'components/NoDataMessage/NoDataMessage'
import { getPeriodTypeForVat } from '../utils/periodUtils'
import { getStatusForVat } from '../utils/statusUtils'
import _ from 'lodash'

const EPRReturnsSection = ({ declarationsEpr, fetchingEPR, user, t, navigate }) => {
	const rows = declarationsEpr ? declarationsEpr.items : []

	return (
		<Card
			title={t("home.title.eprRet")}
			actions={[
				{
					content: t("home.viewAll"),
					onClick: () => navigate("/epr-reporting"),
				},
			]}
			sectioned={fetchingEPR || _.isEmpty(rows)}
		>
			{fetchingEPR ? (
				<Spinner />
			) : (
				<>
					<div style={{ display: "flex", justifyContent: "space-between", alignItems: 'flex-start' }}>
						<h2 style={{ fontSize: 18, fontWeight: '600' }}>{t("home.title.eprRet")}</h2>
						<button
							style={{
								maxHeight: '20px',
								borderColor: 'transparent',
								boxShadow: 'none',
								background: 'transparent',
								height: 'auto',
								color: 'rgba(44, 110, 203, 1)',
								cursor: 'pointer',
								fontSize: 14,
								fontWeight: 400,
							}}
							onClick={() => navigate("/epr-reporting")}
						>
							{t("home.viewAll")}
						</button>
					</div>
					{!_.isEmpty(rows) && !fetchingEPR && (
						<>
							<br />
							<div className='border-top table-dashboard-returns'>
								<LappaPolarisDataTableShell
									columnContentTypes={[
										"text",
										"text",
										"text",
										"numeric",
									]}
									headings={[]}
									rows={[...rows].map((rowData) => [
										rowData.name,
										getPeriodTypeForVat(rowData.period_type, t),
										`${rowData.period} ${rowData.period_type} ${rowData.period_year}`,
										getStatusForVat(rowData.status, t),
									])}
								/>
							</div>
						</>
					)}
					{_.isEmpty(rows) && !fetchingEPR && (
						<div>
							<NoDataMessage
								title={t("home.noDataYet")}
								description={t("home.addEprReturnsToSeeData")}
								buttonText={
									user.vat_returns_show_in_menu
										? t("home.addEprReturn")
										: null
								}
								style={{ height: "auto" }}
								onClick={() => navigate("/epr-reporting/add")}
							/>
						</div>
					)}
				</>
			)}
		</Card>
	)
}

export default EPRReturnsSection

